import React from 'react';
import { Container } from 'react-bootstrap';

const Notfound = () => {
    return (
        
          <Container className="py-5 my-5">
              <h2 className="text-danger text-center py-5 my-5">404 Page not Found</h2>
          </Container>  
        
    );
};

export default Notfound;